// Deliberately separate from the application dependency graph: static imports
// in main.tsx/manual vendor chunks can evaluate BEFORE main's first statement.
// Scrub callback URLs and install release diagnostics before importing that graph.
import './services/questradeCallbackBootstrap'
import { startCanonicalApplication } from './services/canonicalOrigin'
import { renderPreMountError } from './services/preMountErrorView'

startCanonicalApplication({
  location: window.location,
  replace: url => { window.location.replace(url) },
  loadApplication: () => import('./main'),
  onLoadError: () => {
    // Includes dependency evaluation and chunk acquisition failures. Never log
    // the rejected value; retain a visible recovery path if React never mounted.
    console.error('VitaHelm startup failed')
    renderPreMountError({ title: 'STARTUP_FAILED' })
  },
})
